import React from 'react';
import { View } from 'react-native';
import PhotoCard from 'app/src/elements/PhotoCard';
import DocumentCard from 'app/src/elements/DocumentCard';

export const photosContainer = {
  display: 'flex',
  flexDirection: 'row'
}

export const documentsContainer = {

}

const Attachments = props => {
  const { indexType, attachments, updateAttachments } = props;
  return (
    <View style={getContainer()}>
      {getContent()}
    </View>
  )

  function getContent() {
    return (
      attachments?.map(attachment =>
        indexType === 'photos' ?
          <PhotoCard
            key={`photo-${attachment.id}`}
            attachment={attachment}
            updateAttachments={updateAttachments}
          /> :
          <DocumentCard
            key={`document-${attachment.id}`}
            attachment={attachment}
            updateAttachments={updateAttachments}
          />
      )
    )
  }

  function getContainer() {
    return indexType === 'photos' ? photosContainer : documentsContainer
  }
}

export default Attachments;